import { DeploymentRequestInfomationInputDialogState } from ".";
import { Option } from "../../../util/option";
import {
  DEFAULT_DPLYMNT_TIME,
  DPLY_IMPL_TYPE,
} from "./DeploymentRequestInfomationInputDialogConstant";

export const DeploymentRequestInfomationInputDialogInitialState: DeploymentRequestInfomationInputDialogState =
  {
    dplymntReqType: "",
    processTyp: "",
    deploymentRequestList: [],
    updateifListMap: [],
    createifListMap: [],
    componentMap: [],
    dplyImplType: DPLY_IMPL_TYPE.IMMEDIATELY_DEPLOY,
    dplymntDate: "",
    dplymntTime: DEFAULT_DPLYMNT_TIME,
    generalCodes: {
      deploymentDivisionType: [] as Option[],
    },
    isShow: false,
    isSaved: true,
    fieldPath: {
      dplyImplType: "dplyImplType",
      dplymntDate: "dplymntDtime",
      dplymntTime: "dplymntDtime",
    },
    onCreateComponentDeploymentRequestError: () => {},
  };
